export default {
    start: 'find-num-commande',
    process: require('../process/num_commande').default
}



// WEBPACK FOOTER //
// ./src/processes/conf/num_commande.js